// forms/safetyAuditForm/state.js

import { photosUIInitialState } from "../photosForm/photosFormState";
import { filtersInitialState } from "../../shared/filters/filtersState";
import { jsaFormInitialState } from "../jsaForm/jsaFormState";

export const safetyAuditFormUIInitialState = {
  loading: false,
  activeTab: "form", // "form" | "photos" | "jsa" | "findDel"
  // DEL search state
  delSearchResults: [],
  delSearchTotalCount: 0,
  delSearchCurrentPage: 1,
  delSearchPageSize: 10,
  delSearchFilters: filtersInitialState({}),
  delSearchFilterPhaseList: [],
  delSearchShowFilterMenu: false,
  delSearchSelectedDelId: null,
  delSearchLoading: false,
  // JSA tab state
  jsaLoading: false,
};

export const safetyAuditAutosaveErrorsInitialState = {
  hasErrors: false,
  lastError: null,
  fieldErrors: {},
};

export const safetyAuditFormInitialState = {
  safetyAuditFormUI: safetyAuditFormUIInitialState,
  jsaFormUI: jsaFormInitialState,
  photosUI: { ...photosUIInitialState },
  autosaveErrors: safetyAuditAutosaveErrorsInitialState,
};
